import { mapActions } from "vuex";

export default {
  created() {
  },
  data() {
    return {
      uploadingFile: false,
      updateText: false,
      // TODO: do it better ! 
      snakbarInfoMessage: "",
      showInfoSnackbar: false,
      infoSnackbarTimeout: 2000 // in milliseconds 
    }
  },
  methods: {
    ...mapActions("profile", [
      "updateProfileField",
      "uploadFile",
      "removeProfileField"
    ]),
    validateForm() {
      // perform form validation
      this.$v.$touch();

      // return validation result (true/false)
      return !this.$v.$invalid;      
    },    
    async onTextChange(fieldName, fieldValue) {

      this.updateText = true;

      try {
        await this.updateProfileField({
          fieldName: fieldName,
          fieldValue: fieldValue
        });
      } finally {
        this.updateText = false;
      }

    },
    async onFileChanged(file, refId, objectRef) {


      // here we first upload the file and then store it
      // in the user profile
      const formData = new FormData();
      // add the file that has been picked by the user
      formData.append("file", file, file.name);

      this.uploadingFile = true;

      const res = await this.uploadFile(formData);

      this.uploadingFile = false;

      // attach to uploaded file to the user profile
      await this.updateProfileField({
        fieldName: refId,
        fieldValue: res._id
      });
      

      this[refId] = res._id;
      this[objectRef] = res;

    },
    async onFileCleared(refId, objectRef) {

      this[refId] = "";

      this[objectRef] = {
        originalName: ""
      };

      await this.removeProfileField(refId);
    },
    async onFileOpen(objectRef){
      if (!this[objectRef]){
        return;
      }
      const url = this[objectRef].url
      if (url){
        window.open(url, '_blank');
      }
    }
  }
};